import React from 'react';
import { Box, Toolbar } from '@mui/material';
import ResponsiveAppBar from '../../components/AppBar';
import Drawer from '../../components/Drawer';
import { Route, Routes } from 'react-router-dom';
import DashboardPage from './DashboardPage';
import ProfilePage from './ProfilePage';
import SettingsPage from './SettingsPage';
import AboutPage from './AboutPage';
import ErrorPage from '../Common/error';
import config, { DrawerMenuI } from '../../assets/config';
import LoadingIndicator from '../../components/Loading';
import SessionsPage from './Sessions';
import SpeakersPage from './Speakers';
import AttendeesPage from './Attendees';
import CompaniesPage from './Companies';
import FaqPage from './FAQ';
import ContactUsInboxPage from './ContactUs';
import ContentPages from './ContentPages';
import { FloorPlansPage } from './FloorPlans';
import TypeChangePage from './TypeChange';
import NotificationsPage from './Notifications';
import VenuePage from './VenuesPage';
import OrganizerPage from "./OrganizersPage";

const notFoundPage = (
  <ErrorPage
    title='404'
    message='Page not found!'
    redirect='/'
    redirectLabel='Go Home!'
  />
);

const underDevelopment = (
  <ErrorPage
    title='Work in progress'
    message='This page is still being developed'
    redirect='/'
    redirectLabel='Go Home!'
  />
);

function RenderDynamicRoutes() {
  const routes = [...config.drawerMenuTop, ...config.drawerMenuBottom];
  return routes.map((item: DrawerMenuI) => (
    <Route
      id={`route-${item.id}`}
      index={item.index || false}
      path={item.route}
      element={item.component}
    />
  ));
}

export default function (props: any) {
  return (
    <Box sx={{ display: 'flex' }}>
      <LoadingIndicator loading={props.loading} />
      <ResponsiveAppBar {...props} />
      <Drawer {...props} />
      <Box component='main' sx={{ flexGrow: 1, p: 4 }}>
        <Toolbar />
        <Routes>
          {/* <!-- Drawer Menu Top --> */}
          <Route index element={<DashboardPage {...props} />} />
          <Route path='/venue' element={<VenuePage />} />
          <Route path='/organizers' element={<OrganizerPage />} />
          <Route path='/sessions' element={<SessionsPage />} />
          <Route path='/attendees' element={<AttendeesPage />} />
          <Route path='/speakers' element={<SpeakersPage />} />
          <Route path='/companies' element={<CompaniesPage />} />
          <Route path='/faq' element={<FaqPage />} />
          <Route path='/contact-us-messages' element={<ContactUsInboxPage />} />
          <Route path='/change-type' element={<TypeChangePage />} />
          <Route path='/pages' element={<ContentPages />} />
          <Route path='/cloud-message' element={underDevelopment}></Route>
          <Route path='/notifications' element={<NotificationsPage />}></Route>
          <Route path='/card-printing' element={underDevelopment}></Route>
          {/* <!-- Drawer Menu Bottom --> */}
          <Route path='/profile' element={<ProfilePage {...props} />} />
          <Route path='/settings' element={<SettingsPage />} />
          <Route path='/about' element={<AboutPage />} />
          {/* <!-- Error Handlers --> */}
          <Route path='/error/not-found' element={notFoundPage} />
          <Route path='*' element={notFoundPage} />
        </Routes>
      </Box>
    </Box>
  );
}
